<template>
    <div class="home">
        <div class="hero">
            <h1>curie</h1>
            <h2>
                Your HSC Chemistry
                <vue-writer 
                    style="display: inline; font-weight: 700;" 
                    :array="typingWords" 
                    :typeSpeed="40" 
                    :eraseSpeed="80"
                />
            </h2> 
            <div class="cta-buttons">
                <router-link to="/practice" class="btn btn-primary">Try Now</router-link>
                <h6 class="log-in">Already have an account? <router-link to="/login" class="log-in-link">Log in</router-link></h6>
                <!--
                    <router-link to="/register" class="btn btn-secondary">Register</router-link>
                -->
            </div>
        </div>
    </div>
</template>

<script>
import { VueWriter } from 'vue-writer';

export default {
    name: 'HeroSection',
    components: {
        VueWriter
    },
    data() {
        return {
            typingWords: [' Weapon', ' Advantage', ' Solution', ' Edge']
        };
    }
};
</script>

<style scoped>
.home {
    position: relative;
    z-index: 2;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
}

.hero {
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    display: flex;
    color: white;
}

h1 {
    font-size: 128px;
    margin-bottom: 20px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    letter-spacing: 3px;
    color: var(--text-secondary);
}

h2 {
    font-size: 30px;
    font-weight: lighter;
    margin-bottom: 40px;
    opacity: 0.9;
    color: var(--text-primary);
}

.cta-buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-direction: column;
    max-width: 200px;
}

.btn {
    padding: 15px 40px;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: transform 0.2s, box-shadow 0.2s;
    display: inline-block;
    border-radius: 1px;
}

.btn-primary {
    background: var(--text-primary);
    color: var(--bg-primary);
}

.log-in {
    color: rgba(var(--text-primary-rgb), 0.5);
    margin-top: -10px;
    font-weight: 300;
}

.log-in a {
    text-decoration: none !important;
    font-weight: 800;
    color: rgba(var(--text-secondary-rgb), 1) !important;
}

.log-in-link:visited {
    color: rgba(var(--text-secondary-rgb), 1) !important;
}

.btn-secondary {
    background: rgba(255, 255, 255, 0.2);
    color: var(--text-primary);
    border: 2px solid var(--text-primary);
}

.btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
    h1 {
        font-size: 64px;
    }
    
    h2 {
        font-size: 24px;
    }
}
</style>